module.exports = __webpack_public_path__ + "img/insta.328fc0a4.svg";